import { get, post } from "services/httpService";

const SERVICE_URLS = {
  getAllNotifications: () => `notifications`,
  clearNotifications: () => "notifications/clear/",
  markAsReadNotification: () => "notifications/seen/",
  getNotificationsCount: () => "notifications/unseen-count/",
};

export const getAllNotifications = (params) =>
  get(SERVICE_URLS.getAllNotifications(), params);

export const clearNotifications = (payload) =>
  post(SERVICE_URLS.clearNotifications(), payload);

export const markAsReadNotification = (payload) =>
  post(SERVICE_URLS.markAsReadNotification(), payload);

export const getNotificationsCount = async () => {
  let response = await get(SERVICE_URLS.getNotificationsCount());
  return response.unseen_notifications_count;
};
